import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-primary-300 text-primary-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Каталог товаров
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Все категории YOYBUY
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Выберите категорию и перейдите к покупкам на нашей основной платформе Kaspreadsheet
          </p>
        </div>

        {/* Category Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center justify-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-secondary-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors mb-3">
                <i className="ri-shopping-bag-3-line w-6 h-6 md:w-7 md:h-7 flex items-center justify-center text-secondary-500 group-hover:text-primary-500 transition-colors"></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 text-center whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}